// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ka-3";
export var downloadButton = "_ka-4";
export var fileContainer = "_ka-9 _ka-7";
export var fileContainerBase = "_ka-7";
export var fileContainerBaseSm = "_ka-a _ka-7";
export var fileContainerFixedHeight = "_ka-8 _ka-7";
export var fileContainerFixedHeightSm = "_ka-c _ka-a _ka-7";
export var fileContainerSm = "_ka-b _ka-a _ka-7";
export var fileInfo = "_ka-5";
export var fileInfoWidthRestricted = "_ka-6";
export var fileType = "_ka-1";
export var fileTypeName = "_ka-2";
export var fileTypeSm = "_ka-d _ka-1";
export var image = "_ka-0";
export var link = "_ka-f";
export var overflowEllipsis = "_ka-e";